<template>
    <div class="  con_content">
        <div class="container">
            <div class="container_top h_48">
                举报管理
               
            </div>
            
            <div >

                <!-- table组件 -->
                <div class="my_table">
                    <!-- <Header class="my_title txt_l">
                        <span class='my_titleL'>
                            <Icon class="fw_900 " type="ios-list" size='30'/>     
                            筛选查询
                        </span>
                    
                    </Header> -->
                    <div class="my_search">
                        
                        <Row class="search_row">  
                            <div  class="search_name">                             
                            <Button class="mR5"    type="info"    @click='route="/layout/circle/classify/add";addFun();' > <Icon type="md-add" />添加</Button>                              
                            </div>
                            
                        </Row>
                     
                    </div>
                
                
                </div>
                <!-- table组件 -->
                <div class="my_table  ">
                    <Header class="my_title txt_l">
                        <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                            数据列表 
                        </span>
                        
                        <div class="ct_rgt">
                            
                            <!-- <div class="sta_btn " type="primary"   @click="exportData">导出数据</div> -->
                            
                        </div>
                    </Header>
                    <Table     border :columns="columns1" :data="data1" ref='table'>
                    
                        
                        
                       
                        <!-- 按钮 -->
                        <template slot-scope="{ row, index }" slot="btn">
                            <!-- <Poptip trigger="hover" :title="row.surname" content="查看"> -->
                            
                            <Poptip trigger="hover"   content="编辑">
                                <Button class="padlr5" size="small"  @click='route="/layout/circle/classify/editor";editorFun(row)'  type="success"      icon="md-open"></Button>
                            </Poptip>
                            <Poptip trigger="hover"  content="删除">
                                <Button class="padlr5"  size="small" @click='route="/layout/circle/classify/del";delFun(row)'  type="error"      icon="md-close"></Button>
                            </Poptip>
                        
                        </template>
                        
                    </Table>
                
                    <!-- 用户组编辑弹窗 -->
                    <Modal
                        v-model="modal1"
                        title="举报编辑"
                    
                        class-name="vertical-center-modal"
                    >
                        <div slot="footer">
                            <Button type='text' size='large' @click='cancel1'>取消</Button>
                            <Button type='primary' size='large' @click='ok1'>修改</Button>
                        </div>
                        <ul class="list_ul">
                        
                                
                            <!-- 排序 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 排序 :</div> 
                                <div class="list_con">
                                    <Input  v-model="model1"    type='text' class="ipt"  placeholder="请输入排序"    />
                                </div>                                            
                            </li>
                            <!-- 名称 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 名称 :</div> 
                                <div class="list_con">
                                    <Input   v-model="model2"   type='text' class="ipt"  placeholder="请输入名称"    />
                                </div>                                            
                            </li>                                          
                            
                        
                        
                        </ul>
                    </Modal>
                    

                    <!-- 用户组添加弹窗 -->
                    <Modal
                        v-model="modal2"
                        title="举报添加"
                    
                        class-name="vertical-center-modal"
                    >
                        <div slot="footer">
                            <Button type='text' size='large' @click='cancel_add'>取消</Button>
                            <Button type='primary' size='large' @click='ok_add'>添加</Button>
                        </div>
                        <ul class="list_ul">
                        
                                
                            <!-- 排序 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 排序 :</div> 
                                <div class="list_con">
                                    <Input  v-model="model1"    type='text' class="ipt"  placeholder="请输入排序"    />
                                </div>                                            
                            </li>
                            <!-- 名称 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 名称 :</div> 
                                <div class="list_con">
                                    <Input   v-model="model2"   type='text' class="ipt"  placeholder="请输入名称"    />
                                </div>                                            
                            </li>                                          
                            
                        
                        
                        </ul>
                    </Modal>
                    <!-- 确认删除框 -->
                    <Modal
                        v-model="delM"
                        title="提示"
                        @on-ok="delOk"
                        @on-cancel="cancel"
                        class-name="vertical-center-modal"
                    >
                        <p>确定删除吗?</p>
                        
                    </Modal>
                </div>

            </div>

       </div>
       
  </div>
</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    import { format } from 'path';
    

    export default {
        name:'classify',
        data () {
            return {
                route: null,
                token:'',
               

                columns1:[],
                  
                data1:[],
                

                checkGuid2:'',
           
              
  
                modal1: false, // 编辑举报
                modal2: false,   //添加举报
                delM: false,

                model1: null,
                model2: null
                
            }
        },
     
        watch:{
           
          
        },
       
        computed: {
         
         
            
        },
        
        methods: {
           load(){
                let that = this;
              
                that.$myAjax.get(
                     'admin/service/admin/report/type'
                ).then(res => {
                   that.columns1 = [
                       {title:'排序',key:'sort',align:'center'},
                       {title:'名称',key:'name',align:'center'},
                       {title:'添加时间',key:'createTime',align:'center'},
                       
                       {title:'操作',slot:'btn',align:'center',fixed: 'right'}
                   ];
                   that.data1 = res.data.data;
                   
                });
              

                 

              
           },

          
            
           // 用户组名编辑
            editorFun(res){
                let that = this;
               

                that.$canBtn( that.route).then( function(res_c){
                    that.modal1 = true;
    
                    that.guid = res.guid;
                    that.model1 = res.sort;
                    that.model2 = res.name;
                   
                })
            },
           

            //    编辑弹窗
            ok1() {
                var that = this;
                that.$ajax({
                
                    method:'put',
                    url: 'admin/service/admin/report/type?route=/layout/circle/classify/editor',
                    data: {
                        "guid": that.guid,
                        "sort": that.model1,
                        "name": that.model2
                    },
                   
                }).then(res => {
                    that.$alert.info(res);
                    if(res.data.code == 1){
                        that.load();
                        that.cancel1();
                    }
                }).catch(err=>{
                    console.log(err)
                })

                
                
            },
            cancel1() {
                this.modal1 = false;
               
               
            },
           
            // 删除用户组
            delFun(res){
                let that = this;

                that.guid = res.guid;
                that.$canBtn( that.route).then( function(res_c){
                    that.guid = res.guid;
                    that.delM = true;
                })
            },
            delOk(){
                let that = this;
                that.$ajax({
                
                    method:'delete',
                    url: 'admin/service/admin/report/type?guid='+that.guid+'&route='+that.route,
                    data:{
                    },
                   
                }).then(res => {
                    that.$alert.info(res);
  
                    that.load();
                })
                
            },
            
            
            // 顶部添加
            
            addFun(){
                let that = this;
                

                that.$canBtn( that.route).then( function(res_c){
                    that.modal2 = true;

                    that.model1 = null;
                    that.model2 = null;
                  
                })
            },
            ok_add(){
                let that = this;
                
                that.$myAjax.post(
                    'admin/service/admin/report/type?route=',
                    {
                        sort: that.model1,
                        name: that.model2
                    }
                    ).then(res => {
                    // that.$alert.info(res);
                    
                    if(res.data.code != 0){
                        that.load();
                        that.cancel_add();
                    }
                    
                })
                    
                
               
            },
            cancel_add(){
            
                this.modal2 = false;
            },

            cancel(){},

            
         
        },
        mounted: function(){
           var that = this;
           that.vCropper = that.$store.state.vCropper;
           
           that.token = that.$store.state.token;
           
           that.load();
          
    
        }
    }
</script>
<style scoped>
     /* public 内容用  /就行 */
     @import "/css/modal.css";

    

    
</style>




